export default __webpack_public_path__ + "static/media/xfannychristine.93dc43eb.jpg";